import randomColor from 'randomcolor';
import { prettyFloat } from 'utils';
import { RfTypes } from 'z3k-parser/lib';
const _rftype_titles = {
    MLT: 'Термодатчик',
    MLK: 'Брелок',
    MLW: 'Датчик протечки',
    MLM: 'Датчик движения',
    MLH: 'Датчик влажности',
    _ebr: 'Реле блокировки',
    _hood: 'Модуль капота',
    _handsfree: 'Радиометка',
    _handsfree_bat: 'Радиометка c АКБ',
    bt_smartphone: 'Смартфон',
};
export const rf_title_by_type = (rf_type, slot) => {
    const title = _rftype_titles[rf_type] || 'Неизвестный';
    if (slot == null)
        return title;
    const display_slot = rf_type === '_ebr' ? slot - 10 + 1 : slot + 1;
    return `${title} №${display_slot}`;
};
export const rf_color = (serial) => randomColor({ luminosity: 'dark', seed: serial });
const show_temp_for_rf_types = ['MLT', 'MLM', 'MLH', 'MLW'];
export const show_temp_for_rf_type = (type) => show_temp_for_rf_types.includes(type);
export const human_serial = (serial) => {
    if (serial == null)
        return null;
    return serial.replace(/%/g, '');
};
export function calcBatteryVoltage(rf_type, bat_v) {
    if (rf_type === RfTypes._handsfree_bat) {
        return 3.3 + (0.9 * bat_v) / 15;
    }
    return 2 + (1 * bat_v) / 15;
}
export function getStrForBatteryVoltage(bat, bat_v, type) {
    return bat_v != null
        ? `${prettyFloat(bat_v, 1)} B`
        : bat != null
            ? `${prettyFloat(calcBatteryVoltage(type, bat), 1)} В`
            : '';
}
